import { render } from "./BxsSwitchField.vue?vue&type=template&id=4c28d13a&scoped=true"
import script from "./BxsSwitchField.vue?vue&type=script&lang=js"
export * from "./BxsSwitchField.vue?vue&type=script&lang=js"

import "./BxsSwitchField.vue?vue&type=style&index=0&id=4c28d13a&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c28d13a"]])

export default __exports__